export const SET_IS_LOADING = 'CONFIG/SET_IS_LOADING';
export const SET_IMAGE_URL = 'CONFIG/SET_IMAGE_URL';
export const SET_IMAGE_PATH = 'CONFIG/SET_IMAGE_PATH';
export const SET_CONFIGURATIONS = 'CONFIG/SET_CONFIGURATIONS';
export const CLEAR_CONFIGURATIONS = 'CONFIG/CLEAR_CONFIGURATIONS';